import { addRequestCallback, addResponseCallback, startInterceptorService, } from '../interceptor/interceptor.service';
/**
 * @ngdoc service
 * @name proximus.core.entity:$entityManager
 * @requires EntityService
 * @description
 * # $entityManager
 *  A facade service for CRUD operations of Entities.
 */
export default class EntityManager {
    constructor(entityService, configurationService) {
        this.entityService = entityService;
        this.configurationService = configurationService;
    }
    /**
     * creates new entity for provided entity configuration and parameters
     * @memberof proximus.core.entity:$entityManager
     * @param {EntityConfig} configuratio of entity
     * @param {Map} parameters to create entity URL.
     * Parameters must be passed in the order they should appear in the URL placeholders.
     * @returns {Entity} entity
     */
    createEntity(entityConfig, parameterMap) {
        return this.entityService.createEntity(entityConfig, parameterMap);
    }
    /**
     * retrieves entity for provided entity configuration
     * @memberof proximus.core.entity:$entityManager
     * @param {EntityConfig} configuratio of entity
     * @param {Map} parameters to create entity URL.
     * Parameters must be passed in the order they should appear in the URL placeholders.
     * @returns {Rx.Subject} subject for which entity will be resolved
     */
    getEntity(entityConfig, parameterMap) {
        return this.entityService.getEntity(entityConfig, parameterMap);
    }
    /**
     * retrieves entity for provided entity configuration
     * @memberof proximus.core.entity:$entityManager
     * @param {Entity} entity to be used for head method
     * @returns {Rx.Subject} subject for which entity will be resolved
     */
    headEntity(entityConfig) {
        return this.entityService.headEntity(entityConfig);
    }
    /**
     * saves entity to backend - POST request
     * @memberof proximus.core.entity:$entityManager
     * @param {IEntity} entity to be saved
     * @returns {Rx.Subject} subject which gets resolved with saved entity
     */
    saveEntity(entity) {
        return this.entityService.saveEntity(entity);
    }
    /**
     * updates entity to backend - PUT request
     * @memberof proximus.core.entity:$entityManager
     * @param {Entity} entity to be updated
     * @returns {Rx.Subject} subject which gets resolved with updated entity
     */
    updateEntity(entity) {
        return this.entityService.updateEntity(entity);
    }
    /**
     * deletes entity from backend
     * @memberof proximus.core.entity:$entityManager
     * @param {Entity} entity to be deleted
     * @returns {Rx.Subject} subject to which deleted entity gets resolved
     */
    deleteEntity(entity) {
        return this.entityService.deleteEntity(entity);
    }
    cancelEntityRequest(entity) {
        return this.entityService.cancelEntityRequest(entity);
    }
    configure(configuration) {
        this.configurationService.configure(configuration);
    }
    getStrategies() {
        return this.configurationService.getStorageStrategies();
    }
    addInterceptors(onRequests, onResponses) {
        try {
            if (onRequests && onRequests.length > 0) {
                onRequests.forEach(onRequest => addRequestCallback(onRequest));
            }
            if (onResponses && onResponses.length > 0) {
                onResponses.forEach(onResponse => addResponseCallback(onResponse));
            }
            if (this.configurationService.isEnableInterceptor()) {
                startInterceptorService();
            }
        }
        catch (e) {
            this.configurationService.onErrorCallback(e);
        }
    }
}
